import Grid from '@mui/material/Grid';
import React from 'react';
import FormControl from '@mui/material/FormControl';
import { DataField } from '../../atoms';

export type ActionProps = {
  onChange: any
  value: any

};
const ActionRow = (props: ActionProps) => {
  const handleChange = (event: {}) => {
    const e = event as React.ChangeEvent<HTMLInputElement>;
    props.onChange({
      ...props.value,
      [e.target.name]: e.target.value,
    })
  }

  const { value: action } = props
  return (
    <>

      <Grid item xs={5}>
        <FormControl fullWidth>
          <DataField id="ddbed6af-a4d4-4900-8674-a0813bddd24b"
            name="outboundWebhook"
            value={action.name}
            onChange={handleChange}
            label="Outbound Webhook"
            defaultValue={props.value.eventActionValue ? props.value.eventActionValue : ""}
            type="text" />
        </FormControl>
      </Grid>
      <Grid item xs={5}>
        <FormControl fullWidth>
          <DataField id="ccdb6c50-6952-4e3b-8939-79d63312acd5"
            label='Headers'
            name="header"
            value={action.name}
            defaultValue={props.value.outboundWebhookHeader ? props.value.outboundWebhookHeader : ""}
            onChange={handleChange}
            infoText="Optional headers to be added to the webhook call"
            type="text" />
        </FormControl>

      </Grid>
    </>

  )


};

export default ActionRow;